import { render } from "./WorkoutInsights.vue?vue&type=template&id=336550fa&scoped=true&ts=true"
import script from "./WorkoutInsights.vue?vue&type=script&lang=ts"
export * from "./WorkoutInsights.vue?vue&type=script&lang=ts"

import "./WorkoutInsights.vue?vue&type=style&index=0&id=336550fa&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-336550fa"]])

export default __exports__